module.exports = __webpack_public_path__ + "static/media/menu.93d6259b.svg";